import React from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import { message } from 'antd'
import styles from './index.module.less'
import Comment from './comment'

export const EmitterEvent = {
  COMMON_TOTAL: 'COMMON_TOTAL'
}

export default ({
  blogId = null,
  collectId = null,
  loginUserInfo = null,
  createUserId = null,
  type = 0,
  sampleId = null,
  total = 0,
  onInitCommentTotal,
}) => {
  return <div className={styles.commentInfo}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.title}>
        <div className={styles.mainTitle}>
          评论 <span style={{
          marginLeft: '8px',
          fontWeight: '600',
          color: 'var(--m-text-3)' }}
          >{total}</span>
        </div>
        <Button
          type="normal"
          onClick={async () => {
            try {
              // 评论导出
              await request.get('/zhikuan/ins/inspiration/export-blog-comment', {
                params: {
                  collectOrSampleId: type === 0 ? collectId : sampleId,
                  type,
                  pageUrl: location.href
                }
              })
              message.success('导出成功，可在数据导出列表下载')
            } catch (error) {
              message.error('导出失败，请重试')
            }
          }}
        >导出</Button>
      </div>
    </div>
    <Comment
      blogId={blogId}
      loginUserInfo={loginUserInfo}
      collectId={collectId}
      createUserId={createUserId}
      type={type}
      sampleId={sampleId}
      onInitCommentTotal={onInitCommentTotal}
    />
  </div>
}
